import { SocketConnectionWorker } from '../../../components/SocketConnection';
import { EVENT_IS_OPEN } from '../../../components/SocketConnection/constants';
import { getUserId } from '../../../Services/UserService';
import { browserTabIdAtom } from '../AppState';

const setIsLastRidePlayerOpenToSocketServerEffect =
  () =>
  ({ onSet, getPromise }): void => {
    onSet(async (newValue: number | false) => {
      const browserTabId = await getPromise(browserTabIdAtom);
      const data = {
        event: EVENT_IS_OPEN,
        payload: ['ridePlayer', newValue],
        userId: getUserId(),
        browserTabId,
      };
      SocketConnectionWorker.postMessage(data);
    });
  };

export default setIsLastRidePlayerOpenToSocketServerEffect;
